import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('24', '30', 'NORMAL')};
  margin-bottom: 1.5rem;
`;

export const StyledSubTitleModal = styled.p`
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  margin-bottom: 1.5rem;
`;

export const StyledButton = styled(Button)`
  &&& {
    min-height: 2.5rem;
    width: 100%;
    color: ${COLORS.WHITE};
    background-color: ${COLORS.RED};
    border-color: transparent;

    &&&:hover {
      background-color: ${COLORS.RED};
    }
  }
`;
